var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.809 17.88c.012-.078.018-.157.017-.236v-13.4l.133.293c.133.285.314.545.534.768l3.69 3.757c.464.495 1.21.578 1.768.197a1.375 1.375 0 0 0 .173-2.038L9.452.426A1.317 1.317 0 0 0 7.565.425h-.001L.892 7.222a1.377 1.377 0 0 0 .133 2.038 1.363 1.363 0 0 0 1.768-.197l3.697-3.75c.196-.2.36-.43.487-.68l.18-.408V17.57a1.401 1.401 0 0 0 1.12 1.433A1.338 1.338 0 0 0 9.81 17.88z",
    fill: "#F6B119",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.3fbf3c9cdf2f291b2a9313881f4a47bf.svg";
export { ForwardRef as ReactComponent };